<template>
  <div>
    <div id="comments"></div>
    <a id="mc-link" href="http://cackle.me">
      Комментарии для сайта <b style="color: #4fa3da">Cackl</b><b style="color: #f65077">e</b>
    </a>
  </div>
</template>

<script>
import store from '@/store';

export default {
  props: {
    widget_id: {
      required: true,
    },
    language: store.getters.currentLanguage.translationKey,
  },
  created() {
    var mc = document.createElement("script");
    mc.type = "text/javascript";
    mc.async = true;
    mc.src =
        ("https:" == document.location.protocol ? "https" : "http") +
        "://cackle.me/widget.js";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(mc, s.nextSibling);
  },
  methods: {
    register() {
      var vm = this;
      window.cackle_widget = window.cackle_widget || [];
      window.cackle_widget.push(
          Object.assign({
            widget: "Comment",
            id: vm.widget_id,
            callback: {
              ready: [
                function (app, init) {
                  vm.$emit("ready", app, init);
                },
              ],
            },
            container: "comments",
            channel: `${window.location}`,
          })
      );
    },
  },
  mounted() {
    this.register();
  },
};
</script>
